export default __webpack_public_path__ + "static/media/iconLogo16.121d9667.svg";